module.exports = __webpack_public_path__ + "img/20241119_2.62a3bb0e.jpg";